import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import { Icon } from '@jutro/components';
import PropTypes from 'prop-types';
import { withAuthenticationContext } from 'gw-digital-auth-react';
import {
    TranslatorContext, withIntl
} from '@jutro/locale';
import { UserService } from 'gw-capability-gateway';
import { ServiceManager } from '@jutro/services';
import { PhoneUtil } from 'gw-portals-viewmodel-js';
import cx from 'classnames';
import {getFontIcon} from '../../../../utils/lobIconUtil';
import { ViewModelForm } from 'gw-portals-viewmodel-react';
import metadata from './Summary.metadata.json5';
import EditContacts from '../EditContacts/EditContacts';
import summaryStyles from './Summary.module.scss';
import messages from '../Accounts.messages';

class Summary extends Component {
    static propTypes = {
        authHeader: PropTypes.shape({}).isRequired,
        fromAccountLanding: PropTypes.shape({
            accountDetailsData: PropTypes.shape({}).isRequired
        }).isRequired,
        history: PropTypes.shape({
            push: PropTypes.func
        }).isRequired,
        intl: PropTypes.func.isRequired
    };

    static contextType = TranslatorContext;

    state = {
        accountData: '',
        showEditLink: true,
        initialData: '',
        showNewQuoteButton: false
    };

    componentDidMount = () => {
        const { fromAccountLanding } = this.props;
        this.getShowNewQuoteButton();
        this.setState({
            accountData: fromAccountLanding.accountDetailsData,
            initialData: _.cloneDeep(fromAccountLanding.accountDetailsData)
        });
        this.hasUserAccesstoEditAccounts();
    };

    hasUserAccesstoEditAccounts = () => {
        const { authHeader, checkPermission } = this.props;
        
        this.setState({
            showEditLink: checkPermission('editaccountsummary')
        });
        
        // const permissionDTO = {
        //     permission: 'editaccountsummary'
        // };
        // UserService.hasUserSystemPermission(permissionDTO, authHeader).then(
        //     (editUserPermission) => {
        //         this.setState({
        //             showEditLink: editUserPermission
        //         });
        //     }
        // );
    };

    getShowNewQuoteButton = async () => {
        const { authHeader, checkPermission } = this.props;

        this.setState({
            showNewQuoteButton: checkPermission('createsubmission')
        });

        // const permissionDTO = {
        //     permission: 'createsubmission'
        // };
        // const showNewQuoteButton = await UserService.hasUserSystemPermission(
        //     permissionDTO,
        //     authHeader
        // );
        // this.setState({ showNewQuoteButton });
    };

    getPolicyTable = () => {
        const { accountData } = this.state;
        const { intl } = this.props;
        const policyArray = accountData.policySummaries;
        return policyArray.map((policyDetails) => {
            return {
                productCode: policyDetails.product.productCode,
                productName: policyDetails.product.productName,
                insuredName: policyDetails.primaryInsuredName,
                displayStatus: policyDetails.displayStatus,
                policyNumber: policyDetails.policyNumber,
                effectiveDate: intl.formatDate(new Date(policyDetails.effective), { year: 'numeric', month: 'short', day: 'numeric' }),
                expirationDate: intl.formatDate(new Date(policyDetails.expiration), { year: 'numeric', month: 'short', day: 'numeric' })
            };
        });
    };

    getContactDisplayName = (accountHolder) => {
        return accountHolder.subtype === 'Person' ? (`${accountHolder.firstName} ${accountHolder.lastName}`) : accountHolder.contactName;
    }

    readValue = (id, path) => {
        const { accountData } = this.state;
        return _.get(accountData, path);
    };

    getCell = (item, index, { id: property }) => {
        const translator = this.context;
        const toolTipMessage = {
            displayStatus: translator(messages.displayStatus),
            insuredName: translator(messages.insuredName),
            effectiveDate: translator(messages.effectiveDate),
            expirationDate: translator(messages.expirationDate)
        };
        return <span title={toolTipMessage[property]}>{item[property]}</span>;
    };

    getProductImage = (item) => {
        const icon = getFontIcon(item.productCode);
        return (
            <Icon
                icon={icon}
                title={item.productCode}
            />
        );
    };

    getPolicyNoLink = (item, index, { id: property }) => {
        const translator = this.context;
        const toolTipMessage = translator(messages.policyNumber);
        return (
            <>
                <Link
                    to={`/policies/${item[property]}/summary`}
                    className={cx(summaryStyles.remove_link_style)}
                    title={toolTipMessage}
                >
                    {item[property]}
                </Link>
            </>
        );
    };

    handleEditButtonClick = () => {
        this.setState({ showEditLink: false });
    };

    handleNewQuoteClick = () => {
        const { history } = this.props;
        const {
            accountData: { accountNumber }
        } = this.state;
        return history.push(`/new-quote/${accountNumber}`);
    };

    getAccountHolderStateandPostalCode = (accountData) => {
        return `${accountData.accountHolder.primaryAddress.state} ${accountData.accountHolder.primaryAddress.postalCode}`;
    };

    getAccountDisplayStatus = (accountData) => {
        return `${accountData.statusDisplayName}`;
    };

    getPhoneNumber = (accountData) => {
        let primaryPhoneNumber = '';
        const localeService = ServiceManager.getService('locale-service');
        const phoneUtil = PhoneUtil();
        switch (accountData.accountHolder.primaryPhoneType) {
            case 'work':
                primaryPhoneNumber = accountData.accountHolder.workNumber ? `${accountData.accountHolder.workNumber} ext ${accountData.accountHolder.workNumberExtension}` : '';
                break;
            case 'home':
                primaryPhoneNumber = accountData.accountHolder.homeNumber ? `${accountData.accountHolder.homeNumber} ext ${accountData.accountHolder.homeNumberExtension}` : '';
                break;
            case 'mobile':
                primaryPhoneNumber = accountData.accountHolder.cellNumber ? `${accountData.accountHolder.cellNumber} ext ${accountData.accountHolder.cellNumberExtension}` : '';
                break;
            default:
                primaryPhoneNumber = '';
        }
        return phoneUtil.prettyPrint(primaryPhoneNumber, localeService.getDefaultCountryCode());
    };

    getPhoneNumber = (accountData, phoneType) => {
        let primaryPhoneNumber = '';
        const localeService = ServiceManager.getService('locale-service');
        const phoneUtil = PhoneUtil();
        switch (phoneType) {
            case 'work':
                primaryPhoneNumber = accountData.accountHolder.workNumber ? `${accountData.accountHolder.workNumber} ext ${accountData.accountHolder.workNumberExtension}` : '';
                break;
            case 'home':
                primaryPhoneNumber = accountData.accountHolder.homeNumber ? `${accountData.accountHolder.homeNumber} ext ${accountData.accountHolder.homeNumberExtension}` : '';
                break;
            case 'mobile':
                primaryPhoneNumber = accountData.accountHolder.cellNumber ? `${accountData.accountHolder.cellNumber} ext ${accountData.accountHolder.cellNumberExtension}` : '';
                break;
            default:
                primaryPhoneNumber = '';
        }
        return phoneUtil.prettyPrint(primaryPhoneNumber, localeService.getDefaultCountryCode());
    };

    getPhoneNumberVisibility = (accountData) => {
        if (accountData.accountHolder.primaryPhoneType) {
            return true;
        }
        return false;
    };

    showEditOnCancel = (onSaving) => {
        const { initialData, accountData } = this.state;
        if (onSaving) {
            this.setState({
                showEditLink: true,
                initialData: _.cloneDeep(accountData)
            });
        } else {
            this.setState({
                showEditLink: true,
                accountData: _.cloneDeep(initialData)
            });
        }
    };

    render() {
        const { accountData, showEditLink, showNewQuoteButton } = this.state;
        const translator = this.context;
        if (_.isEmpty(accountData)) {
            return null;
        }
        const policySummaryArray = this.getPolicyTable();

        const overrides = {
            PolicyTable: {
                data: policySummaryArray
            },
            name: {
                content: this.getContactDisplayName(accountData.accountHolder)
            },
            addressline1: {
                content: _.get(accountData, 'accountHolder.primaryAddress.addressLine1', '-')
            },
            addressline2: {
                content: _.get(accountData, 'accountHolder.primaryAddress.addressLine2', '-')
            },
            addressline3: {
                content: _.get(accountData, 'accountHolder.primaryAddress.addressLine3', '-')
            },
            city: {
                content: _.get(accountData, 'accountHolder.primaryAddress.city')
            },
            homePhoneNoLabel: {
                visible: _.get(accountData, 'accountHolder.subtype') === 'Person',
            },
            homePhoneNo: {
                visible: _.get(accountData, 'accountHolder.subtype') === 'Person',
                content: this.getPhoneNumber(accountData, 'home')
            },
            workPhoneNo: {
                content: this.getPhoneNumber(accountData, 'work')
            },
            mobilePhoneNo: {
                content: this.getPhoneNumber(accountData, 'mobile')
            },
            noDataMessage: {
                visible: _.isEmpty(policySummaryArray)
            },
            stateAndPostalcode: {
                content: this.getAccountHolderStateandPostalCode(accountData)
            },
            renewals: {
                content: _.toString(accountData.numberOfOpenPolicyRenewals)
            },
            cancellations: {
                content: _.toString(accountData.numberOfOpenPolicyCancellations)
            },
            changes: {
                content: _.toString(accountData.numberOfOpenPolicyChanges)
            },
            accountStatus: {
                content: this.getAccountDisplayStatus(accountData)
            },
            homePhoneNoLabel: {
                visible: this.getPhoneNumberVisibility(accountData),
                content: _.get(accountData, 'accountHolder.primaryPhoneType')  === 'home'
                    ? translator(messages.homePhonePrimary)
                    : translator(messages.homePhone)
            },
            workPhoneNoLabel: {
                content: _.get(accountData, 'accountHolder.primaryPhoneType')  === 'work'
                    ? translator(messages.workPhonePrimary)
                    : translator(messages.workPhone)
            },
            mobilePhoneNoLabel: {
                content: _.get(accountData, 'accountHolder.primaryPhoneType')  === 'mobile'
                    ? translator(messages.mobilePrimary)
                    : translator(messages.mobile)
            },
            phoneNumber: {
                content: this.getPhoneNumber(accountData),
                visible: this.getPhoneNumberVisibility(accountData)
            },
            editContacts: {
                visible: !showEditLink,
                accountData: accountData,
                showEditOnCancel: this.showEditOnCancel
            },
            showEdit: {
                visible: showEditLink
            },
            newQuoteButton: {
                visible: showNewQuoteButton
            },
            producerCode: {
                content: _.get(accountData, 'producerCodes[0].displayValue')
            }
        };

        const resolvers = {
            resolveCallbackMap: {
                getCell: this.getCell,
                getProductImage: this.getProductImage,
                getPolicyNoLink: this.getPolicyNoLink,
                handleEditButtonClick: this.handleEditButtonClick,
                handleNewQuoteClick: this.handleNewQuoteClick
            },
            resolveValue: this.readValue,
            resolveClassNameMap: summaryStyles,
            resolveComponentMap: {
                editcontactscomponent: EditContacts
            }
        };

        return (
            <div className={cx(summaryStyles.summary)}>
                <ViewModelForm
                    uiProps={metadata.pageContent}
                    model={accountData}
                    overrideProps={overrides}
                    callbackMap={resolvers.resolveCallbackMap}
                    componentMap={resolvers.resolveComponentMap}
                    classNameMap={resolvers.resolveClassNameMap}
                />
            </div>
        );
    }
}
export const SummaryComponent = Summary;
export default withIntl(withAuthenticationContext(Summary));
